import { STATUS_META } from "@/lib/domain";

export function StatusBadge({ status, testId }) {
  const meta = STATUS_META[status] || { label_ru: status, cls: "bg-slate-500/20 text-slate-300 border-slate-500/30" };
  return (
    <span
      data-testid={testId || "object-status-badge"}
      className={`inline-flex items-center px-2.5 py-1 text-xs font-medium border rounded-md ${meta.cls}`}
    >
      {meta.label_ru}
    </span>
  );
}

export function Chip({ children, className = "" }) {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-md text-[11px] font-medium border ${className}`}>
      {children}
    </span>
  );
}
